var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { INSURER_CONFIG } from '@shared/insurer';
const claim = namespace('claim');
let ChiffrageIdDeclaration = class ChiffrageIdDeclaration extends Vue {
    constructor() {
        super(...arguments);
        /*
      
        IMPORTANT
      
        Pour fermer l'iframe, le selfcare doit envoyer un message "iframe:close" à la fenêtre parente, comme ceci :
      
        window.parent.postMessage('iframe:close', '*');
      
        */
        this.messageListener = async (event) => {
            var _a;
            if (event.data === 'iframe:close') {
                await this.$store.dispatch('claim/selectClaim', {
                    id: this.id,
                    edit: false,
                    identifier: (_a = INSURER_CONFIG.backoffice) === null || _a === void 0 ? void 0 : _a.claimUrlIdentifier,
                });
                this.$goToLocalePath({ name: 'chiffrage-id-chiffrage', params: { id: this.id } });
            }
        };
    }
    get id() {
        return this.$route.params.id;
    }
    mounted() {
        window.addEventListener('message', this.messageListener);
    }
    beforeUnmount() {
        window.removeEventListener('message', this.messageListener);
    }
};
__decorate([
    claim.State('magicLink')
], ChiffrageIdDeclaration.prototype, "magicLink", void 0);
__decorate([
    claim.State('info')
], ChiffrageIdDeclaration.prototype, "info", void 0);
ChiffrageIdDeclaration = __decorate([
    Component({
        nuxtI18n: {
            paths: {
                en: '/counting/:id/claim',
            },
        },
    })
], ChiffrageIdDeclaration);
export default ChiffrageIdDeclaration;
